<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="chatroomUploadFile"
  >
    <v-card tile>
      <v-btn icon absolute left top large @click="dialog = false">
        <v-icon large>close</v-icon>
      </v-btn>
      <v-btn dark fab fixed right bottom large color="pink" @click="send">
        <v-icon large>send</v-icon>
      </v-btn>
      <v-responsive 
        v-if="dialog"
        :width="$vuetify.breakpoint.xsOnly ? 300 : 600"
        :max-width="$vuetify.breakpoint.xsOnly ? 300 : 600" 
        :max-height="$vuetify.breakpoint.xsOnly ? 300 : 400"
      >
        <v-img 
          v-if="file.type.startsWith('image')"
          class="no-background"
          contain
          max-width="100%"
          max-height="100%"
          :src="url" 
        ></v-img>
        <video-player
          v-else-if="file.type.startsWith('video')"
          class="video-player" 
          :playsinline="true" 
          :options="$func.videoOption({
            src: url,
            type: file.type,
            autoplay: true,
            loop: true,
            controls: false,
          })"></video-player>
        <audio v-else-if="file.type.startsWith('audio')" :src="url" :type="file.type" controls controlsList="nodownload noplaybackrate"></audio>
      </v-responsive>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      url: null,
      file: null
    }
  },
  methods: {
    open(file) {
      this.file = file
      this.url = URL.createObjectURL(file)
      this.dialog = true
    },
    send() {
      this.$emit('send', this.file)
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.chatroomUploadFile {
  .v-card {
    margin-top: 60px !important;
    min-height: unset !important;
    height: calc(100% - 60px);
    padding: 12px !important;
    background: $grey-1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .video-js {
    background: transparent;
  }
  audio {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%  );
  }
}
</style>